/**
 * 网商需要获取错误信息 放开500的判断
 * @author 陶姚姚
 * @date 2020-7-20
 *
 */
import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";

// create an axios instance
const requestGetError = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? window.BaseUrl.devUrl
      : window.BaseUrl.ApiUrl, // url = base url + request url
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 300000 // request timeout
});

// request interceptor
requestGetError.interceptors.request.use(
  config => {
    // console.log(config.data)
    // 去除字段
    if (config.data) {
      if (config.data.gmtCreated) {
        delete config.data.gmtCreated;
      }
      if (config.data.gmtModified) {
        delete config.data.gmtModified;
      }
    }
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      var _getToken = "Bearer " + getToken();
      config.headers["Authorization"] = _getToken;
      config.headers["deviceId"] = "0000000000";
    }
    return config;
  },
  error => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
requestGetError.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (
      res.status === 21332 /* || res.status === 50012 || res.status === 50014 */
    ) {
      // to re-login
      MessageBox.confirm(
        "登录超时由于长时间无操作，您的登录会话已超时。请重新登录以继续。",
        "提示",
        {
          confirmButtonText: "重新登录",
          type: "警告"
        }
      ).then(() => {
        store.dispatch("user/resetToken").then(() => {
          location.reload();
        });
      });
      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      return res;
    }
  },
  error => {
    Message({
      message: error.msg,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default requestGetError;
